<template>
  <v-col
    class="ma-0 px-2 pt-2 pb-1"
    id="height-grouped-row"
    v-if="hasVisibleChildren"
  >
    <v-row
      dense
      align="center"
      class="group-row py-2"
      @click="expanded = !expanded"
    >
      <v-icon small class="mr-2">
        {{ expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}
      </v-icon>
      <strong>{{ group.label }}</strong>
    </v-row>

    <v-expand-transition>
      <div v-show="expanded" class="pl-4 my-1">
        <template v-if="isGroupLevel(group.children)">
          <group-row
            v-for="(child, i) in group.children"
            :key="i"
            :group="child"
            :headers="headers"
            :search="search"
          />
        </template>
        <template v-else>
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            class="nested-table"
            hide-default-footer
            disable-pagination
            dense
            style="min-width: 100%"
          />
        </template>
      </div>
    </v-expand-transition>
  </v-col>
</template>

<script>
export default {
  name: "GroupRow",
  props: {
    group: { type: Object, required: true },
    headers: { type: Array, required: true },
    search: String,
  },
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    hasVisibleChildren() {
      if (this.isGroupLevel(this.group.children)) {
        return this.group.children.some((child) =>
          this.recursivelyHasVisibleChildren(child)
        );
      } else {
        return this.filteredItems.length > 0;
      }
    },
    filteredItems() {
      if (!this.search) return this.group.children;

      const term = this.search.toLowerCase();
      return this.group.children.filter((item) => {
        return Object.values(item).some((val) =>
          String(val).toLowerCase().includes(term)
        );
      });
    },
  },
  methods: {
    isGroupLevel(children) {
      return (
        Array.isArray(children) &&
        children.length &&
        typeof children[0] === "object" &&
        "label" in children[0] &&
        "children" in children[0]
      );
    },
    recursivelyHasVisibleChildren(group) {
      if (this.isGroupLevel(group.children)) {
        return group.children.some((child) =>
          this.recursivelyHasVisibleChildren(child)
        );
      } else {
        const term = this.search?.toLowerCase() || "";
        return group.children.some((item) =>
          Object.values(item).some((val) =>
            String(val).toLowerCase().includes(term)
          )
        );
      }
    },
  },
  components: {
    GroupRow: () => import("./GroupedRow.vue"),
  },
};
</script>
<style scoped>
.group-row {
  cursor: pointer;
  background-color: #f0f0f0;
  border-left: 4px solid #1976d2;
  border-radius: 4px;
}
.nested-table {
  margin-top: 6px;
}
#height-grouped-row {
  max-height: 60vh;
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
